import React from 'react'
import { useParams } from 'react-router-dom'
import { jwtDecode, JwtPayload } from 'jwt-decode'
import { HttpStatus } from '@notino/react-toolkit/renderer/fragment/contexts/HttpContext'

// types
import { ContextProps } from '../types/types'

// components
import MyReservationPage from '../pages/MyReservationPage/MyReservationPage'

// utils
import { TOKEN_AUD } from '../utils/enums'
import { myReservationPageQuerySchema } from '../utils/zodQuerySchemas'

// hooks
import useZodQueryParams from '../hooks/useZodQueryParams'

type MyReservationRouteParams = {
	reservationID: string
}

const MyReservationRoute: React.FC<React.PropsWithChildren<ContextProps>> = (props) => {
	const { reservationID } = useParams<MyReservationRouteParams>()

	const [query, setQuery] = useZodQueryParams(myReservationPageQuerySchema)

	if (!props.isAuthorized) {
		let validToken: string | undefined

		try {
			/**
			 * t: A query parameter added by the backend to the URL in the email, representing a token.
			 * This token is often duplicated in the URL, so it is processed as an array.
			 */
			if (query.t && query.t.length > 0) {
				const decodedToken = jwtDecode<JwtPayload>(query.t[0])
				if (decodedToken.aud === TOKEN_AUD.CANCEL_RESERVATION) {
					;[validToken] = query.t
				}
			}
		} catch (e) {
			// eslint-disable-next-line no-console
			console.error(e)
		}

		if (!validToken) {
			return (
				<HttpStatus status={404} {...props}>
					{null}
				</HttpStatus>
			)
		}
	}

	return <MyReservationPage {...props} reservationID={reservationID as string} query={query} setQuery={setQuery} />
}

export default MyReservationRoute
